export interface BillOfMaterialsItem {
  id: string;
  billOfMaterialsHeaderId: string;
  billOfMaterialsHeaderProductId: string;
  productId: string;
  productKey: string;
  productOldCode: string;
  productShortDescription: string;
  productDescription: string;
  productTypeId: string;
  productTypeDescription: string;
  partNo: string;
  sequence: number;
  ratio: number;
  amountRequired: number;
  quantity: number;
  suppliedByUs: boolean;
  suppliedByUsYesNo: string;
  manufacturerProduct: boolean;
  manufacturerProductYesNo: string;
  customerDefinedQuantity: boolean;
  customerDefinedQuantityString: string;
}
